import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface ServiceRingProps {
  rotation: number;
}

// The 1/5 progress ring that spins to the active service (GSAP back.out(3) in the original).
export function ServiceRing({
  rotation
}: ServiceRingProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div aria-hidden="true" animate={{
    rotate: rotation
  }} transition={reduceMotion ? {
    duration: 0
  } : {
    type: 'spring',
    stiffness: 130,
    damping: 9,
    mass: 0.9
  }} className="relative m-[0.1rem] h-[140px] w-[140px] overflow-hidden rounded-full" style={{
    backgroundImage: 'conic-gradient(#0055ff 20%, #ebecf0 0)'
  }} data-id="element-151" data-mp="20dhbmit2uukd">
      <div className="absolute left-1/2 top-1/2 h-[130px] w-[130px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white" data-id="element-152" data-mp="2j51qyj4796fu" />
    </motion.div>;
}